import React from 'react'
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import Loader from '../../shared/Loader/Loader';

const RejectedIntakeFormPopup = (props) => {
    const { isDiscardChanges, handleCancelDiscard, onProceedWithDiscardChanges, FormName, FormID, isLoading } = { ...props }

    const select = () => {
        return <p className='heading Rejected_clr'>Confirm Rejection</p>;
    };
    return (
        <Modal show={isDiscardChanges} onHide={handleCancelDiscard} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
            <ModalHeader HeaderName={select} DeletePopup={""} isClosed={handleCancelDiscard} key={111} Name={'DiscardChangesPopup'} />
            <Modal.Body>
                {isLoading ? <Loader/> : null}
                <div className='ar-alert d-flex mb-12'>
                    <i className='icon-alert mt-1'></i>
                    <div>
                        <p className='text ms-1'>Are you sure you want to reject ths? This action cannot be undone.</p>
                    </div>
                </div>
            </Modal.Body>

            <div className="modal_footer za_br_light br-top-1 pt-2 ">
                <div className='za-button text-end d-flex justify-content-end gap-2'>
                    <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={handleCancelDiscard}>Cancel</button>
                    <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => onProceedWithDiscardChanges(FormName, FormID)}>Reject</button>
                </div>
            </div>
        </Modal>
    )
}

export default RejectedIntakeFormPopup